import React from "react"
import Slider from "react-slick"
import ArrowRight from "../../assets/keyboard-right-arrow-button.svg"
import ArrowLeft from "../../assets/left-arrow-key.svg"
import styles from "./slider.module.scss"

const SampleNextArrow = props => {
  const { className, style, onClick } = props //eslint-disable-line
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        height: "40px",
        width: "40px",
        borderRadius: "50%",
        zIndex: "100",
        right: "20px",
        paddingLeft: "5px",
      }}
      onClick={onClick}
    >
      <ArrowRight className={styles.arrow} />
    </div>
  )
}

const SamplePrevArrow = props => {
  const { className, style, onClick } = props //eslint-disable-line
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        height: "40px",
        width: "40px",
        borderRadius: "50%",
        zIndex: "100",
        left: "20px",
      }}
      onClick={onClick}
    >
      <ArrowLeft className={styles.arrow} />
    </div>
  )
}

const settings = {
  infinite: true,
  arrows: true,
  nextArrow: <SampleNextArrow className={styles.arrow_container} />,
  prevArrow: <SamplePrevArrow className={styles.arrow_contaner} />,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  // adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        dots: true,
        arrows: false,
      },
    },
  ],
}

const NewSlider = ({ slides }) => (
  <Slider {...settings} className={`${styles.wrapper}`}>
    {slides}
  </Slider>
)

export default NewSlider
